import { ms } from "../../../../date-fns/locale/ms.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ms
  }
};